import { SetState } from "../../lib/typeDeclarations";
import { Paginator } from "../paginator/Paginator";
import "./header.css";

type ItemCounterType = {
  page: number;
  limit: number;
  total: number;
  setPage: SetState;
};

export default function Header({
  itemCounter,
  children,
}: {
  itemCounter?: ItemCounterType;
  children: React.ReactNode;
}) {
  return (
    <div id="header">
      {itemCounter ? (
        <div className="item-counter">
          <div className="">{`${(itemCounter.page - 1) * itemCounter.limit + 1} - ${
            itemCounter.page * itemCounter.limit > itemCounter.total
              ? itemCounter.total
              : itemCounter.page * itemCounter.limit
          } / ${itemCounter.total}`}</div>
          <Paginator
            pages={Math.ceil(itemCounter.total / itemCounter.limit)}
            currentPage={itemCounter.page}
            setPage={itemCounter.setPage}
          />
        </div>
      ) : (
        <div></div>
      )}
      <div className="header-childrens">{children}</div>
    </div>
  );
}
